import MetaDataStrip from '@/components/common/MetaDataStrip';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import React, { useContext } from 'react';

const AboutProgram = ({ isArmature }: { isArmature: boolean }) => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { meta } = courseDetails || {};

  return <MetaDataStrip meta={meta} className={`${isArmature ? 'bg-white' : 'bg-blue-50'}`} />;
};

export default AboutProgram;
